type Props = {
  src: string;
  alt: string;
  dimmed?: boolean;
};

export default function LiveEvaluationPlayerImage({ src, alt, dimmed = false }: Props) {
  return (
    <img
      src={src}
      alt={alt}
      className={`absolute inset-0 block h-full w-full object-contain ${dimmed ? "opacity-40" : ""}`}
    />
  );
}
